export default [
  {
    path: '/overview',
    name: 'overview',
    component: () => import('@/views/overview/Overview.vue'),
    meta: {
      action: 'read',
      resource: 'Overview',
      breadcrumb: [
        {
          text: 'Tổng quan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/overview-my-team',
    name: 'overview-my-team',
    component: () => import('@/views/overviewTeam/OverviewMyTeam.vue'),
    meta: {
      action: 'read',
      resource: 'OverviewMyTeam',
      breadcrumb: [
        {
          text: 'Tổng quan',
          active: true,
        },
      ],
    },
  },
]
